// extracted by mini-css-extract-plugin
module.exports = {"background":"_2lhac2r7Cz-HtQXcpxh9P6"};